module.exports = function getResource(label, vars = []) {
    const resources = {
        review: 'Commentaire',
        rateHeading: 'Évaluer ce produit',
        writeReview: 'Rédiger votre commentaire',
        writeReviewExample: 'Example: After using this product over the past few weeks, I am loving the results! It has helped keep my dry skin feeling hydrated. Application is easy, and theformula is...',
        rateAndReview: 'Évaluer et commenter',
        headline: 'Titre',
        headlineExample: 'Example: A must-have in my routine!',
        optional: 'facultatif',
        addAHeadline: 'Ajouter un titre',
        maxChar: `Max. ${vars[0]} caractères`,
        seeFull: 'Voir en entier',
        addPhoto: 'Ajouter une photo',
        upToTwoImages: 'jusqu’à deux images',
        wouldYouRecommendThisProduct: 'Recommanderiez-vous ce produit?',
        yes: 'Oui',
        no: 'Non',
        productAsAfreeSample: 'J’ai reçu ce produit en échantillon gratuit',
        sephoraEmployee: 'Je suis un employé de Sephora',
        next: 'Suivant',
        errorMessageText: `L’évaluation doit comporter au moins ${vars[0]} caractères`,
        errorMessageRating: 'Veuillez sélectionner une étoile pour évaluer',
        errorMessageTextRecommend: 'Veuillez faire un choix',
        termsAndConditions: 'Terms and Conditions',
        termsError: 'You must agree to our Terms and Conditions to continue',
        yesAgree: 'Yes, I agree to the'
    };
    return resources[label];
};
